"use client";

import Carousel from "@/components/common/Carousel";
import HotelDealItemSkeleton from "./HotelDealItem.skeleton";

type FlashSaleDealsDesktopSkeletonProps = {
  type?: "sample" | "default"
};


const FlashSaleDealsDesktopSkeleton = ({
  type = "default"
}: FlashSaleDealsDesktopSkeletonProps) => {

  return (
    <Carousel
      className="carousel-main home__deals-hotels--list"
      options={{
        pageDots: false,
        cellAlign: "left",
        draggable: true,
        prevNextButtons: true,
        contain: true,
        groupCells: true
      }}
    >
      {[1, 2, 3, 4].map((i: any) => {
        return (
          <HotelDealItemSkeleton
            itemType={type}
            key={i}
            className="flickity-container flickity-cell"
          />
        );
      })}
    </Carousel>
  );
};

export default FlashSaleDealsDesktopSkeleton;
